// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lazy-row-container__fixed-header {
  z-index: 1;
  position: sticky;
  top: 0;
}

.lazy-row-container__fixed-footer {
  z-index: 1;
  position: sticky;
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/LazyRowContainer/LazyRowContainer.css","webpack://./services/frontend/app/components/LazyRowContainer/LazyRowContainer.css"],"names":[],"mappings":"AADA;ECEE,UAAU;EACV,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".lazy-row-container__fixed-header {\n\n  position: sticky;\n\n  z-index: 1;\n\n  top: 0\n}\n\n.lazy-row-container__fixed-footer {\n\n  position: sticky;\n\n  z-index: 1;\n\n  bottom: 0\n}\n",".lazy-row-container__fixed-header {\n  z-index: 1;\n  position: sticky;\n  top: 0;\n}\n\n.lazy-row-container__fixed-footer {\n  z-index: 1;\n  position: sticky;\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
